import { hotList } from "@/mocks/chigua";

export default function HotRank() {
  return (
    <section id="hot" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-semibold text-primary-700">
              <i className="ri-fire-fill" aria-hidden="true"></i> 现在最火
            </p>
            <h2 className="mt-3 font-display text-3xl text-foreground-900 md:text-4xl">实时热榜</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              热度实时刷新,围观群众都在看的现场都在这
            </p>
          </div>
          <span className="text-xs text-foreground-500">每 30 秒自动更新 · 最近更新于刚刚</span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {hotList.map((item) => {
            const heatPercent = (item.heat / 100) * 100;
            return (
              <a
                key={item.rank}
                href="#feed"
                className="group flex items-center gap-4 rounded-2xl border border-secondary-200 bg-background-50 p-4 transition hover:border-primary-300 hover:bg-white"
              >
                <span
                  className={`font-display flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-xl ${
                    item.rank <= 3
                      ? "bg-primary-500 text-white"
                      : "bg-secondary-100 text-primary-700"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span
                      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold ${
                        item.tag === "爆"
                          ? "bg-accent-500 text-white"
                          : "bg-primary-100 text-primary-700"
                      }`}
                    >
                      {item.tag}
                    </span>
                    <h3 className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700 md:text-base">
                      {item.title}
                    </h3>
                  </div>
                  <div className="mt-2 flex items-center gap-3">
                    <div className="h-1.5 w-full max-w-[220px] overflow-hidden rounded-full bg-secondary-100">
                      <div
                        className="h-full rounded-full bg-primary-400"
                        style={{ width: `${heatPercent}%` }}
                      ></div>
                    </div>
                    <span className="text-xs text-foreground-500">{item.heat}万热度</span>
                    <span
                      className={`text-xs whitespace-nowrap ${
                        item.up ? "text-accent-600" : "text-foreground-400"
                      }`}
                    >
                      {item.up ? "↑" : "↓"} {item.delta}
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}